var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32016 20.106C7.26815 20.106 8.17731 19.7294 8.84764 19.0591C9.51797 18.3887 9.89456 17.4796 9.89456 16.5316V13.4678C9.89456 12.5198 10.2711 11.6107 10.9415 10.9403C11.6118 10.27 12.521 9.89343 13.469 9.89343C14.4169 9.89343 15.3261 9.51684 15.9964 8.84651C16.6668 8.17618 17.0433 7.26702 17.0433 6.31903V1.87952C16.3776 1.77672 15.6955 1.72339 15.0009 1.72339C7.66862 1.72339 1.72461 7.6674 1.72461 14.9997C1.72461 16.8092 2.0866 18.5341 2.74211 20.106H6.32016Z",
    fill: "#426306",
    stroke: "#84C70D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2755 14.7948C27.2532 14.2647 26.1195 13.9849 24.9679 13.9785H20.6174C19.6694 13.9785 18.7602 14.3551 18.0899 15.0254C17.4196 15.6958 17.043 16.6049 17.043 17.5529C17.043 18.5009 17.4196 19.4101 18.0899 20.0804C18.7602 20.7507 19.6694 21.1273 20.6174 21.1273C21.2945 21.1273 21.9439 21.3963 22.4227 21.8751C22.9015 22.3539 23.1705 23.0033 23.1705 23.6804V25.4574H23.1808C26.264 23.0423 28.2522 19.2932 28.2768 15.0787V14.9208C28.2765 14.8788 28.2761 14.8368 28.2755 14.7948Z",
    fill: "#426306",
    stroke: "#84C70D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentIconActive);
export default __webpack_public_path__ + "static/media/agent-icon-active.f147215cd122a408be14b8d7f654fd9e.svg";
export { ForwardRef as ReactComponent };